import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {additionalServicesService} from "../../services/additionalServices.service";

const initialState = {
    additionalServices: [],
    status: ''
}

const getByServiceType = createAsyncThunk('additionalServicesSlice/getByServiceType',
    async ({service_type}) => {
        try {
            const {data} = await additionalServicesService.getByServiceType(service_type);

            return data.results;
        } catch (error) {
            throw error;
        }
    });

const additionalServicesSlice = createSlice({
    name: 'additionalServicesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => builder
        .addCase(getByServiceType.fulfilled, (state, action) => {
            const additionalServices = action.payload;
            // const filteredUniqueServices = Array.from(new Set(additionalServices.map(entry => entry.id)))
            //     .map(id => additionalServices.find(entry => entry.id === id));

            state.additionalServices = additionalServices;

            state.status = 'success';
        })
        .addCase(getByServiceType.pending, (state, action) => {
            state.status = 'loading';
        })
})

const {actions, reducer: additionalServicesReducer} = additionalServicesSlice;

const additionalServicesActions = {
    ...actions,
    getByServiceType,
}

export {
    additionalServicesActions,
    additionalServicesReducer,
}
